import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/products'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'products_wrapper',
          meta: { permissions: ['administrator'] },
          redirect: to => ({ name: 'products_list', params: to.params }),
        },
        {
          path: 'list',
          name: 'products_list',
          meta: { permissions: ['administrator'] },
          component: Index,
        },
      ],
    },
  ],
};
